import * as styles from "./Badge.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Icon } from "@frontend/components/atoms/Icon";

import type { BadgeProps } from "./Badge.types";

export function Badge({
  variant,
  size,
  className,
  children,
  label,
  icon,
  dot = true,
  iconPosition = "start",
  href,
  target,
  rel,
  ...props
}: BadgeProps): JSX.Element {
  const indicator = icon ? (
    <Icon name={icon} className={styles.icon} />
  ) : dot ? (
    <span className={styles.dot({ variant })} />
  ) : null;

  const content =
    iconPosition === "end" ? (
      <>
        {label ?? children}
        {indicator}
      </>
    ) : (
      <>
        {indicator}
        {label ?? children}
      </>
    );

  const badgeClassName = clsx(
    styles.badge({ variant, size, iconPosition }),
    className,
  );

  return href ? (
    <a
      data-slot="badge"
      href={href}
      target={target}
      rel={rel ?? (target === "_blank" ? "noopener noreferrer" : undefined)}
      className={badgeClassName}
      {...(props as React.ComponentPropsWithoutRef<"a">)}
    >
      {content}
    </a>
  ) : (
    <span data-slot="badge" className={badgeClassName} {...props}>
      {content}
    </span>
  );
}
